<template>
  <span class="doc-icon-badge" :class="{ 'doc-icon-badge--tiled': tile }">
    <span class="doc-icon-circle">
      <omk-icon>{{ icon }}</omk-icon>
    </span>
  </span>
</template>

<script>
  export default {
    name: 'DocumentIconBadge',
    props: {
      icon: { type: String, required: true },
      tile: { type: Boolean, default: false },
    },
  };
</script>

<style scoped>
  .doc-icon-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .doc-icon-badge--tiled {
    width: var(--doc-tile-size, 56px);
    height: var(--doc-tile-size, 56px);
    border-radius: var(--doc-tile-radius, 12px);
    background: var(--doc-tile-bg, #ffffff);
  }
  .doc-icon-circle {
    width: var(--doc-badge-size, 36px);
    height: var(--doc-badge-size, 36px);
    border-radius: var(--doc-badge-radius, 50%);
    border: 1px solid
      var(--doc-badge-border, var(--omk-colour-border-active-resting, #0a7d3f));
    background: var(--doc-badge-bg, transparent);
    color: var(
      --doc-badge-color,
      var(--omk-colour-icon-active-resting, #0a7d3f)
    );
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: background 0.15s, border-color 0.15s, color 0.15s;
  }
  .doc-icon-circle omk-icon {
    --omk-icon-size: var(--doc-badge-icon-size, 22px);
  }
</style>
